import store from 'tradera-state/configure-store';
import { setCurrencyIfNotChosen } from 'tradera-state/multi-currency';
import multiCurrencyRenderer from './multi-currency-renderer';

let _booted = false;

const activateMultiCurrency = () => {
    multiCurrencyRenderer.render();
};

const activateDevMultiCurrency = () => {
    multiCurrencyRenderer.render();
    store.dispatch(setCurrencyIfNotChosen('EUR'));
};

const boot = async initData => {
    const multiCurrencyEnabled = !!initData.featureSwitches['multi-currency'];
    if (!multiCurrencyEnabled) {
        return;
    }
    if (_booted) {
        return;
    }

    _booted = true;
    if (window && window.location.search.indexOf('force-currency-dev') > -1) {
        activateDevMultiCurrency();
        return;
    }
    if (initData.memberCountry === 'Sverige') {
        return;
    }

    activateMultiCurrency();
};

export default {
    boot
};
